module.exports = __webpack_public_path__ + "img/1503690944.8d35aac9.jpg";